import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconTransfer } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type TransferButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

/**
 * Component resposible to handler transference display for active calls
 */
const Transfer = ({ onClick, session }: TransferButtonProps) => {
  const {
    answered,
    callActions: { transfer: isTransfer },
  } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <button
      type="button"
      title={t('components.activeCalls.btn.transfer')}
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG src={IconTransfer} selected={isTransfer} />
    </button>
  );
};

export default Transfer;
